import {defineStore} from 'pinia';

import {fetchWrapper} from '@/helpers/fetch-wrapper';
import {showSuccessToast} from "vant";


const baseUrl = `${process.env.VUE_APP_API_URL}/user/goals`;

export const useUserGoalStore = defineStore({
  id: 'userGoal',
  state: () => ({
    goalCategories: [],
    userGoals: [],
    userGoal: {
      progresses:[],
      percentage: 0,
      status: 'Pending',
    },
    search: '',
    status: '',
  }),
  actions: {
    reset() {
      this.userGoal = {
        progresses:[],
            percentage: 0,
            status: 'Pending',
      };
    },

    async fetchCategories() {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      const response = await fetchWrapper.get(`${baseUrl}/` + 'categories?account_id=' + accountId, null);
      this.goalCategories = response.data;
    },

    async fetchAll() {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      const response = await fetchWrapper.get(`${baseUrl}/` + '?search=' + this.search + "&status=" + this.status + "&account_id=" + accountId, null);
      this.userGoals = response.data;
    },

    async fetchOne(id) {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      const response = await fetchWrapper.get(`${baseUrl}/` + id +"?account_id=" + accountId, null);
      this.userGoal = response.data;
    },

    async createOne() {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      const response = await fetchWrapper.post(`${baseUrl}/` + "?account_id=" + accountId, this.userGoal);
      this.userGoal = response.data;
      showSuccessToast('Created');
    },

    async updateOne(id) {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      const response = await fetchWrapper.put(`${baseUrl}/` + id +"/?account_id=" + accountId, this.userGoal);
      this.userGoal = response.data;
      showSuccessToast('Updated');
    },

    async deleteOne(id) {
      const accountId = JSON.parse(localStorage.getItem('user')).patient_account.id;
      await fetchWrapper.delete(`${baseUrl}/` + id +"?account_id=" + accountId, {});
      this.userGoal = {};
      showSuccessToast('Deleted');
    },
  }
});
